import {
  Ability,
  AbilityBuilder,
  ForcedSubject,
  MongoQuery,
  subject
} from '@casl/ability'
import {
  ACTIONS,
  SUBJECTS
} from 'features/ContractsPipelineDetails/Abilities/constants'
import { TFinancialsList } from '../types'

export type Actions = ValueOfObject<typeof ACTIONS>
export type Subjects = ValueOfObject<typeof SUBJECTS>

export type PossibleAbilities = [
  Actions,
  Subjects | (TFinancialsList & ForcedSubject<Subjects>)
]

export type Conditions =
  | Record<PropertyKey, number | string | MongoQuery>
  | MongoQuery<Record<PropertyKey, number | string | MongoQuery>>

export type FinancialsAbility = Ability<PossibleAbilities, Conditions>

export type FinancialsAbilityBuilder = AbilityBuilder<FinancialsAbility>

export const contractSubject = (type, object) =>
  subject<Subjects, TFinancialsList>(type, { ...object })
